import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const SUBSCRIPTION: AppRouteRecordRaw = {
  path: '/subscription',
  name: 'Subscription',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.subscription',
    requiresAuth: true,
    icon: 'icon-calendar',
    order: 4,
  },
  children: [
    {
      path: 'list',
      name: 'SubscriptionList',
      component: () => import('@/views/order/subscription/index.vue'),
      meta: {
        locale: 'menu.subscription.list',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'email-log',
      name: 'EmailLogList',
      component: () => import('@/views/order/email-log/index.vue'),
      meta: {
        locale: 'menu.subscription.emailLog',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default SUBSCRIPTION;
